import React from 'react';
import PropTypes from 'prop-types';
// import { UserAvatar, AvatarSizes } from 'components/avatar';
import './style.scss';

/* const ImageRow = ({ id, label }) => (
  <div className="fm-select-row fm-select-row__image">
    <UserAvatar id={id} size={AvatarSizes.NORMAL} />
    <span className="fm-select-row__label">{label}</span>
  </div>
); */

const ImageRow = ({ id, label = '' }) => (
    <div className="fm-select-row fm-select-row__image">
        <span className="fm-select-row__label">
            {label}
            {id}
        </span>
    </div>
);

ImageRow.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
};

export default ImageRow;
